enum FormFields {
  Email = 'email',
  Password = 'password',
}

const FormFieldsList = [FormFields.Email, FormFields.Password];

export { FormFields, FormFieldsList };
